module.exports = {
    lan :  {
      logName:'User Name/Email/Phone',
      logPwd:'Password',
      logo:require('../assets/wap/logo_rmE.png'),
      logoB:require('../assets/wap/enlogo.png'),
      serTit:'Enter keywords or image numbers',
      imgTit:'Image',
      motion:'Motion',
      adTop:'Premium creative stills and motion,<br/>direct from the source',
      companyJs:'Blue Jean Images produces and curates the best<br/>in Chinese and worldwide creative content, bringing<br/> fresh visual inspiration and highly tailored resources<br/>to ad creatives in China and around the world.',
      salekf:'Sales',
      aboutjean:'About Blue Jean',
      wmail:'Email',
      copynote:'Copyright Notice',
      system:'Leave us a message',
      wapend:'All contents © copyright 2006-2014 Blue Jean Images. <br/>All rights reserved.（2006－2020）Beijing ICP Record 12011872',
      newline:'Newest Images',
      newlineV:'Newest Uploads',
      editorSelects:'Editor Selects',
      purworld:'Purchase and download exclusive new content months before worldwide release!',
      aboutUS :'Contact Us',
      creaImg:'Creative Images',
      creaVideo:'Creative Motion',
      creaVideo2:'Creative Motion',
      browallimg:'Browse All',
      browallvideo:'Browse Videos',
      bycateg:'By Category',
      editTj:'Editor Selects',
      logIn:'Sign In',
      regIn:'Create Account',
      plogIN:'Sign In》',
      recently:'Recently Viewed Images',
      zhword :'中文',
      signyours:'Sign In',
      password:'Password',
      forgotpwd:'Forgotten your password?',
      creatnew:'Create New Account',
      noAccount:'No account?',
      reguser:'Create User Name',
      newpwd:'Create Password',
      conpwd:'Confirm Password',
      mobtel:'Mobile Number',
      vercode:'Enter Code',
      havAccount:'Already have an account?',
      entermail:'Enter email address',
      entercode:'Enter Code',
      senmail:'Send Email',
      telcode:'Send Code',
      mailcode:'Verify Email',
      userName:'Name',
      gender:'Gender',
      datebirth:'Date of Birth（yyyy-mm-dd）',
      compy:'Company',
      indust:'Industry',
      posit:'Position',
      coungj:'Country',
      countrys:'Territory',
      phone:'Phone',
      savecont:'Save and Continue',
      errorPwd:'Please try again',
      email:'Email',
      gsName:'Email address format is incorrect',
      mailerror:'Email Error',
      dailesend:'Daily Attempts Exceeded',
      shortYhm:'User name must be at least 3 characters',
      sucreg:'Registration successful',
      viatel:'Via Text',
      viaemail:'Via Email',
      respwd:'Reset Password',
      beMail:'This email is linked to an existing account',
      codeerror:'Incorrect code',
      pwdsign:'Password reset complete, please sign in',
      pwdfai:'Password reset failed, please retry',
      yourName:'Your name',
      phoneMail:'Phone / Email',
      Message:'Message',
      send:'Send',
      leaveCon:'Leave us a note below and <br/>we’ll get back to you asap.',
      abmiansd:'Thank you for reaching out.<br/>We will get back to you shortly. ',
      desktop:'Desktop Version',
      // 详情页
      bh:'ID:',
      more:'See more ',
      hid:'Less ',
      sysser:"Photographer: ",
      endlicen:"Release: Model and Property Released",
      gjc:"Keywords ",
      // copyright:"本图片版权属于©蓝牛仔影像（北京）有限公司所有",
      checkreadSize:"All Sizes  ",
      hideSize:"Less  ",
      gm:"Buy Now",
      joinCarts:"Add to Cart",
      similarImg:"Similars",
      moreSim:"view more",
      moreshoot:"entire shoot",
      similarVid:"Similars",
      zjll:"Recently Viewed Images",
      checkread:"All ",
        
        //下载小样图小介面
      dcompimg:"Download Comp Image" ,
      choseimgsize:"Choose Image Size",
      agreeterms:"I have read and agree to be bound by the ",
      agreeterms1:"Comp Image Terms of Use",
      downcomp:'Download Comp',
      compzysx:'Note: This comp image is available for the sole purpose of layout creation for internal evaluation only.',
      compzysx1:'Learn more 》',
      dcompimg1:'Comp Image Terms of Use',
      xyttk:'Blue Jean grants you a temporary license to use this comp image for the sole purpose of layout creation for internal evaluation, no other use of the downloaded comp image is permitted. This temporary license is valid for sixty (60) days from the date downloaded or received. For the duration of the license, you will not copy, distribute, publish, or display the image in any manner. After the expiry date, if you have failed to purchase a commercial license, you must destroy all copies of the image. Misuse or publication of the image will leave end user open to infringement penalties under relevant copyright law.',
      secbtn:'confirm',
      ts:'Please select image size',
      ts1:'Please agree to the terms of use',
      down10Text:'Complete user profile to upgrade',
  
      //搜索
      imges:'images',
      tpimg:'Images',
      tpvid:'Videos',
      pages:'pages',
      lsfavo:'My Lightbox',
      signOut:'Sign Out',
      //编辑推荐页
      recom: "Editor Selects",
      //分类搜索页
      classify: "Browse by Category",
      newline1: "newline",
      classifyKey:[
        {src:"https://static.lanniuzai.com/img/newIndex/genre1.jpg" , width:333, height:248, key:"家庭", keyword:"Family"},
        {src:"https://static.lanniuzai.com/img/newIndex/genre2.jpg" , width:384, height:249, key:"商务", keyword:"Business"},
        {src:require("../assets/comimg/genre3.jpg" ) , width:265, height:249, key:"度假", keyword:"Holidays"},
        {src:"https://static.lanniuzai.com/img/newIndex/genre6.jpg" , width:322, height:223, key:"购物", keyword:"Shopping"},
        {src:"https://static.lanniuzai.com/img/newIndex/genre5.jpg" , width:493, height:223, key:"公路,无人", keyword:"Auto Backplates"},
        {src:"https://static.lanniuzai.com/img/newIndex/genre4.jpg" , width:187, height:250, key:"中国文化,无人", keyword:"Culture"},
        {src:"https://static.lanniuzai.com/img/newIndex/genre7.jpg" , width:366, height:223, key:"样板间", keyword:"Interiors"},
        {src:"https://static.lanniuzai.com/img/newIndex/genre11.jpg" , width:345, height:279, key:"运动", keyword:"Sports"},
        {src:"https://static.lanniuzai.com/img/newIndex/genre9.jpg" , width:303, height:270, key:"美容", keyword:"Beauty"},
        {src:"https://static.lanniuzai.com/img/newIndex/genre8.jpg" , width:405, height:270, key:"儿童,老人,中年人,商务,孕妇", keyword:"Millennials"},
        {src:"https://static.lanniuzai.com/img/newIndex/genre10.jpg" , width:472, height:270, key:"工业", keyword:"Industry"},
        {src:"https://static.lanniuzai.com/img/newIndex/genre13.jpg" , width:339, height:280, key:"技术", keyword:"Technology"},
        {src:"https://static.lanniuzai.com/img/newIndex/genre14.jpg" , width:274, height:240, key:"养老", keyword:"Retirement"},
        {src:"https://static.lanniuzai.com/img/newIndex/genre20.jpg" , width:500, height:265, key:"医疗", keyword:"Healthcare"},
        {src:"https://static.lanniuzai.com/img/newIndex/genre12.jpg" , width:496, height:279, key:"童年", keyword:"Childhood"},
        {src:"https://static.lanniuzai.com/img/newIndex/genre15.jpg" , width:287, height:240, key:"商务,团队", keyword:"Teamwork"},
        {src:"https://static.lanniuzai.com/img/newIndex/genre16.jpg" , width:432, height:240, key:"汽车", keyword:"Childhood"},
        {src:"https://static.lanniuzai.com/img/newIndex/genre17.jpg" , width:178, height:240, key:"温泉", keyword:"spa"},
        {src:"https://static.lanniuzai.com/img/newIndex/genre18.jpg" , width:365, height:265, key:"市区,无人", keyword:"City"},
        {src:"https://static.lanniuzai.com/img/newIndex/genre19.jpg" , width:314, height:265, key:"旅游", keyword:"Tourism"},
        {src:"https://static.lanniuzai.com/img/newIndex/genre25.jpg" , width:439, height:275, key:"过年", keyword:"Chinese New Year"},
        {src:"https://static.lanniuzai.com/img/newIndex/genre24.jpg" , width:330, height:290, key:"小朋友,教育", keyword:"education"},
        {src:"https://static.lanniuzai.com/img/newIndex/genre21.jpg" , width:222, height:290, key:"时尚", keyword:"Style"},
        {src:"https://static.lanniuzai.com/img/newIndex/genre22.jpg" , width:428, height:290, key:"婴儿", keyword:"Babies"},
        {src:"https://static.lanniuzai.com/img/newIndex/genre27.jpg" , width:186, height:124, key:"美食,无人", keyword:"Food & Drink"},
        {src:"https://static.lanniuzai.com/img/newIndex/genre26.jpg" , width:327, height:275, key:"一个人,肖像", keyword:"Portraits"},
        {src:"https://static.lanniuzai.com/img/newIndex/genre28.jpg" , width:167, height:251, key:"中医", keyword:"TCM"},
        {src:"https://static.lanniuzai.com/img/newIndex/genre31.jpg" , width:389, height:250, key:"情侣,两个人", keyword:"Couples"},
        {src:"https://static.lanniuzai.com/img/newIndex/genre23.jpg" , width:190, height:290, key:"静物", keyword:"Still Life"},
        {src:"https://static.lanniuzai.com/img/newIndex/genre29.jpg" , width:358, height:250, key:"旅行", keyword:"Travel"},
        {src:"https://static.lanniuzai.com/img/newIndex/genre32.jpg" , width:257, height:250, key:"插画", keyword:"Illustration"},
      ],
      classifykey1:['Logistics','Nightlife','College Life','Music','Fitness','Tea Culture','Hotels','White Background','Family Portraits','Home Ownership','Pets','Retirement','Pregnancy','Birthdays','Marriage','Weight Loss','Moving House','Mid Autmun Festival','Leadership','Meetings','Service','Job Hunting','Small Business','Desginers','Business Travel','Scenics','Spring','Summer','Autumn','Winter'],
  
       //提交订单
       myHome:'My Account',
       cart:'My Cart',
       orders:'Orders',
       lightbox:'Lightboxes',
       down:'Download',
       titPay:'Confirm purchase details',
       creatImg:'Creative Image',
       imgSize:'Image Size',
       dimens:'Dimensions',
       spaceColor:'Color Space',
       typeLicen:'License Type',
       downSize:'Download Size',
       priceyj:'Price',
       pricetj:'Promo',
       redpoint:'Points',
       totalP:'Total Price',
       voucher:'Vouchers',
       coupons:'Coupons',
       points:'Points',
       suborder:'Buy Now',
       orderID:'Order ID',
       todue:'Total Due',
       chospay:'Select Payment Method',
       prcCheck:'Complete Purchase',
       paysh:'Pay Later',
       endUsers:'End User',
       adAgency:'Ad Agency',
       otherThird:'Third Party',
       debitbalan:'Balance',
       offs:'off',
       allOrder:'All',
       opend:'Open',
       completedd:'Completed',
       refundedd:'Refunded',
       canceledd:'Canceled',
       completedsd:'Completed',
       sureDel:'Sure you want to delete?',
       sureCancel:'Sure you want to cancel?',
       upqx:'Cancel',
       qddel:'Delete',
       numrmb:'(￥)',
        numusd:'($)',
        recharg:'Recharge',
       //充值
       addcou1:'Add $100 to earn two $5 coupons',
       addcou2:'Add $200 to earn two $15 coupons',
       addcou3:'Add $500 to earn two $40 coupons',
       addcou4:'Add $1000 to earn two $90 coupons',
       addcou5:'Add $2000 to earn four $100 coupons - and an immediate upgrade to 10MB comps',
       addcou1s:'Add $100 to earn two $5 coupons',
       addcou2s:'Add $200 to earn two $15 coupons',
       addcou3s:'Add $500 to earn two $40 coupons',
       addcou4s:'Add $1000 to earn two $90 coupons',
       addcou5s:'Add $2000 to earn four $100 coupons - and an immediate upgrade to 10MB comps！',
       addfundsLs:'Add Funds',
       addfunds:'Add Funds',
       currentBs:'Current Balance',
       zhangs:'Images',
      //订单
      account:'Account',
      lightboxe:'Lightboxes',
      mycart:'Cart',
      myorder:'Orders',
      download:'Downloads',
  
       //我的账户
       alerts:'Service Notes',
       balance:'Account Balance',
       rechaacunt:'Immediately Recharge',
       Points:'Points',
       Coupon:'Coupon',
       coupones:'Coupons',
       compdown:'Comps',
       zhe:'off',
       date:'Used',
       edit:'Edit',
       hT:'换图',
       WeChat:'WeChat',
       xg:'Reset',
       jb:'unbind',
       xgyx:'Reset Eamil',
       ysyx:'Original Email',
       bdxyx:'Bind New Email',
       yspass:'Original Password',
       qrnewpass:'Confirm New Password',
       xgsj:'Reset Phone',
       yssj:'Original Phone',
       newsj:'New Phone',
       notvou:'Get voucher when you recharge!',
       notcou:'No coupons available!',
  
        //收藏夹
        newFolder:'Create New',
        bjFolder:'Edit Favorites',
        mc:'Name',
        kh:'Client',
        bz:'Info',
        state:'Selection state',
        sm:'Private',
        kfx:'Shared',
        wxts1:'Warm Prompt：',
        ts2:'The "private" status requires a login account to access it，',
        ts3:' Shareable can be accessed without logging in, and links can be Shared.',
        bc:'Save',
        qr:'Confirm',
        canl:'Delete this lightbox',
   }
  }
  
  
  
